import { Component, inject, PLATFORM_ID, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSidenav, MatSidenavContent, MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
  selector: 'app-documentation',
  imports: [
    RouterModule, MatSidenavModule, MatIconModule, MatButtonModule, SidebarComponent
  ],
  templateUrl: './documentation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './documentation.component.css'
})
export class DocumentationComponent {
  @ViewChild(MatSidenavContent) private sidenavContent!: MatSidenavContent;
  @ViewChild('docsSidenav') sidenav!: MatSidenav;

  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  private breakpointObserver = inject(BreakpointObserver);

  isMobile = false;
  sidenavMode: 'side' | 'over' = 'side';
  sidenavOpened = true;

  constructor() {
    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .pipe(takeUntilDestroyed())
      .subscribe(result => {
        this.isMobile = result.matches;
        this.sidenavMode = result.matches ? 'over' : 'side';
        this.sidenavOpened = !result.matches;
      });

    if (isPlatformBrowser(this.platformId)) {
      this.router.events
        .pipe(
          filter((e): e is NavigationEnd => e instanceof NavigationEnd),
          takeUntilDestroyed(),
        )
        .subscribe(e => {
          const fragment = e.urlAfterRedirects.split('#')[1];
          if (fragment) {
            setTimeout(() => {
              const el = document.getElementById(fragment);
              if (!el) return;
              const container = this.sidenavContent.getElementRef().nativeElement;
              const elRect = el.getBoundingClientRect();
              const containerRect = container.getBoundingClientRect();
              container.scrollBy({ top: elRect.top - containerRect.top, behavior: 'smooth' });
            }, 100);
          }
        });
    }
  }

  toggleSidenav(): void {
    this.sidenav.toggle();
  }
}
